import React, { useRef, useState } from "react";
import Layout from "../../layouts/Layout";
import BreadcrumbArea from "../../components/BreadcrumbArea/BreadcrumbArea";
import InnerProjectArea from "../../components/Project/InnerProjectArea";
import { Link } from "react-router-dom";
import BtnTabs from "../../components/Btn-Tabs/btn-tabs";
import DocumentMeta from "react-document-meta";
import { Helmet } from "react-helmet";

const logo_design = [
  {
    url: "#",
    src1: "/img/project-custom/logo-design/1-01.webp",
    src2: "/img/project-custom/logo-design/2-01.webp",
    title: "Logo Design",
    desc: "Timeless Logos, Bold Identities",
  },
  {
    url: "#",
    src1: "/img/project-custom/logo-design/5-01.webp",
    src2: "/img/project-custom/logo-design/4-01.webp",
    title: "Logo Design",
    desc: "Timeless Logos, Bold Identities",
  },
  {
    url: "#",
    src1: "/img/project-custom/logo-design/6-01.webp",
    src2: "/img/project-custom/logo-design/7-01.webp",
    title: "Logo Design",
    desc: "Timeless Logos, Bold Identities",
  },
  {
    url: "#",
    src1: "/img/project-custom/logo-design/8-01.webp",
    src2: "/img/project-custom/logo-design/9-01.webp",
    title: "Logo Design",
    desc: "Timeless Logos, Bold Identities",
  },
  {
    url: "#",
    src1: "/img/project-custom/logo-design/10-01.webp",
    src2: "/img/project-custom/logo-design/11-01.webp",
    title: "Logo Design",
    desc: "Timeless Logos, Bold Identities",
  },
  {
    url: "#",
    src1: "/img/project-custom/logo-design/12-01.webp",
    src2: "/img/project-custom/logo-design/13-01.webp",
    title: "Logo Design",
    desc: "Timeless Logos, Bold Identities",
  },
  {
    url: "#",
    src1: "/img/project-custom/logo-design/14-01.webp",
    src2: "/img/project-custom/logo-design/15-01.webp",
    title: "Logo Design",
    desc: "Timeless Logos, Bold Identities",
  },
  {
    url: "#",
    src1: "/img/project-custom/logo-design/16-01.webp",
    src2: "/img/project-custom/logo-design/10-01.webp",
    title: "Logo Design",
    desc: "Timeless Logos, Bold Identities",
  },
  {
    url: "#",
    src1: "/img/project-custom/logo-design/18-01.webp",
    src2: "/img/project-custom/logo-design/19-01.webp",
    title: "Logo Design",
    desc: "Timeless Logos, Bold Identities",
  },
  {
    url: "#",
    src1: "/img/project-custom/logo-design/20-01.webp",
    src2: "/img/project-custom/logo-design/21-01.webp",
    title: "Logo Design",
    desc: "Timeless Logos, Bold Identities",
  },
];
const web_design = [
  {
    url: "#",
    src1: "/img/project-custom/web-design/1-01.webp",
    src2: "/img/project-custom/web-design/2-01.webp",
    title: "Web Design",
    desc: "Innovative Websites, Seamless Experience",
  },
  {
    url: "#",
    src1: "/img/project-custom/web-design/5-01.webp",
    src2: "/img/project-custom/web-design/4-01.webp",
    title: "Web Design",
    desc: "Innovative Websites, Seamless Experience",
  },
  {
    url: "#",
    src1: "/img/project-custom/web-design/6-01.webp",
    src2: "/img/project-custom/web-design/7-01.webp",
    title: "Web Design",
    desc: "Innovative Websites, Seamless Experience",
  },
  {
    url: "#",
    src1: "/img/project-custom/web-design/8-01.webp",
    src2: "/img/project-custom/web-design/9-01.webp",
    title: "Web Design",
    desc: "Innovative Websites, Seamless Experience",
  },
  {
    url: "#",
    src1: "/img/project-custom/web-design/10-01.webp",
    src2: "/img/project-custom/web-design/11-01.webp",
    title: "Web Design",
    desc: "Innovative Websites, Seamless Experience",
  },
  {
    url: "#",
    src1: "/img/project-custom/web-design/12-01.webp",
    src2: "/img/project-custom/web-design/13-01.webp",
    title: "Web Design",
    desc: "Innovative Websites, Seamless Experience",
  },
  {
    url: "#",
    src1: "/img/project-custom/web-design/14-01.webp",
    src2: "/img/project-custom/web-design/15-01.webp",
    title: "Web Design",
    desc: "Innovative Websites, Seamless Experience",
  },
  {
    url: "#",
    src1: "/img/project-custom/web-design/16-01.webp",
    src2: "/img/project-custom/web-design/7-01.webp",
    title: "Web Design",
    desc: "Innovative Websites, Seamless Experience",
  },
];
const brand_design = [
  {
    url: "#",
    src1: "/img/project-custom/brand-design/1-01.webp",
    src2: "/img/project-custom/brand-design/2-01.webp",
    title: "Brand Design",
    desc: "Defining Identities, Empowering Brands",
  },
  {
    url: "#",
    src1: "/img/project-custom/brand-design/5-01.webp",
    src2: "/img/project-custom/brand-design/4-01.webp",
    title: "Brand Design",
    desc: "Defining Identities, Empowering Brands",
  },
  {
    url: "#",
    src1: "/img/project-custom/brand-design/6-01.webp",
    src2: "/img/project-custom/brand-design/7-01.webp",
    title: "Brand Design",
    desc: "Defining Identities, Empowering Brands",
  },
  {
    url: "#",
    src1: "/img/project-custom/brand-design/8-01.webp",
    src2: "/img/project-custom/brand-design/9-01.webp",
    title: "Brand Design",
    desc: "Defining Identities, Empowering Brands",
  },
  {
    url: "#",
    src1: "/img/project-custom/brand-design/10-01.webp",
    src2: "/img/project-custom/brand-design/11-01.webp",
    title: "Brand Design",
    desc: "Defining Identities, Empowering Brands",
  },
  {
    url: "#",
    src1: "/img/project-custom/brand-design/12-01.webp",
    src2: "/img/project-custom/brand-design/13-01.webp",
    title: "Brand Design",
    desc: "Defining Identities, Empowering Brands",
  },
  {
    url: "#",
    src1: "/img/project-custom/brand-design/14-01.webp",
    src2: "/img/project-custom/brand-design/15-01.webp",
    title: "Brand Design",
    desc: "Defining Identities, Empowering Brands",
  },
  {
    url: "#",
    src1: "/img/project-custom/brand-design/16-01.webp",
    src2: "/img/project-custom/brand-design/17-01.webp",
    title: "Brand Design",
    desc: "Defining Identities, Empowering Brands",
  },
  {
    url: "#",
    src1: "/img/project-custom/brand-design/18-01.webp",
    src2: "/img/project-custom/brand-design/19-01.webp",
    title: "Brand Design",
    desc: "Defining Identities, Empowering Brands",
  },
];
const book_design = [
  {
    url: "#",
    src1: "/img/project-custom/book-design/1-01.webp",
    src2: "/img/project-custom/book-design/2-01.webp",
    title: "Book Design",
    desc: "Crafting Stories, Designing Pages",
  },
  {
    url: "#",
    src1: "/img/project-custom/book-design/5-01.webp",
    src2: "/img/project-custom/book-design/4-01.webp",
    title: "Book Design",
    desc: "Crafting Stories, Designing Pages",
  },
  {
    url: "#",
    src1: "/img/project-custom/book-design/6-01.webp",
    src2: "/img/project-custom/book-design/7-01.webp",
    title: "Book Design",
    desc: "Crafting Stories, Designing Pages",
  },
  {
    url: "#",
    src1: "/img/project-custom/book-design/8-01.webp",
    src2: "/img/project-custom/book-design/9-01.webp",
    title: "Book Design",
    desc: "Crafting Stories, Designing Pages",
  },
  {
    url: "#",
    src1: "/img/project-custom/book-design/10-01.webp",
    src2: "/img/project-custom/book-design/11-01.webp",
    title: "Book Design",
    desc: "Crafting Stories, Designing Pages",
  },
];
const stationary = [
  {
    url: "#",
    src1: "/img/project-custom/stationary/1-01.webp",
    src2: "/img/project-custom/stationary/2-01.webp",
    title: "Stationary",
    desc: "Elevating Brands Through Stationery",
  },
  {
    url: "#",
    src1: "/img/project-custom/stationary/5-01.webp",
    src2: "/img/project-custom/stationary/4-01.webp",
    title: "Stationary",
    desc: "Elevating Brands Through Stationery",
  },
  {
    url: "#",
    src1: "/img/project-custom/stationary/6-01.webp",
    src2: "/img/project-custom/stationary/7-01.webp",
    title: "Stationary",
    desc: "Elevating Brands Through Stationery",
  },
  {
    url: "#",
    src1: "/img/project-custom/stationary/8-01.webp",
    src2: "/img/project-custom/stationary/9-01.webp",
    title: "Stationary",
    desc: "Elevating Brands Through Stationery",
  },
  {
    url: "#",
    src1: "/img/project-custom/stationary/10-01.webp",
    src2: "/img/project-custom/stationary/11-01.webp",
    title: "Stationary",
    desc: "Elevating Brands Through Stationery",
  },
  {
    url: "#",
    src1: "/img/project-custom/stationary/12-01.webp",
    src2: "/img/project-custom/stationary/13-01.webp",
    title: "Stationary",
    desc: "Elevating Brands Through Stationery",
  },
  {
    url: "#",
    src1: "/img/project-custom/stationary/14-01.webp",
    src2: "/img/project-custom/stationary/15-01.webp",
    title: "Stationary",
    desc: "Elevating Brands Through Stationery",
  },
  {
    url: "#",
    src1: "/img/project-custom/stationary/16-01.webp",
    src2: "/img/project-custom/stationary/17-01.webp",
    title: "Stationary",
    desc: "Elevating Brands Through Stationery",
  },
];
const appDesign = [
  {
    url: "#",
    src1: "/img/project-custom/app-design/1-01.webp",
    src2: "/img/project-custom/app-design/2-01.webp",
    title: "Business Card",
    desc: "First Impressions, Lasting Impact",
  },
  {
    url: "#",
    src1: "/img/project-custom/app-design/5-01.webp",
    src2: "/img/project-custom/app-design/4-01.webp",
    title: "Business Card",
    desc: "First Impressions, Lasting Impact",
  },
  {
    url: "#",
    src1: "/img/project-custom/app-design/6-01.webp",
    src2: "/img/project-custom/app-design/7-01.webp",
    title: "Business Card",
    desc: "First Impressions, Lasting Impact",
  },
  {
    url: "#",
    src1: "/img/project-custom/app-design/8-01.webp",
    src2: "/img/project-custom/app-design/13-01.webp",
    title: "Business Card",
    desc: "First Impressions, Lasting Impact",
  },
  {
    url: "#",
    src1: "/img/project-custom/app-design/14-01.webp",
    src2: "/img/project-custom/app-design/15-01.webp",
    title: "Business Card",
    desc: "First Impressions, Lasting Impact",
  },
  {
    url: "#",
    src1: "/img/project-custom/app-design/16-01.webp",
    src2: "/img/project-custom/app-design/13-01.webp",
    title: "Business Card",
    desc: "First Impressions, Lasting Impact",
  },
];
const businessAdvertising = [
  {
    url: "#",
    src1: "/img/project-custom/bussiness-advertising/business-advertizing-01-min.webp",
    src2: "/img/project-custom/bussiness-advertising/business-advertizing-02-min.webp",
    title: "Bussiness Advertising",
    desc: "Driving Growth, Amplifying Succes",
  },
  {
    url: "#",
    src1: "/img/project-custom/bussiness-advertising/business-advertizing-03-min.webp",
    src2: "/img/project-custom/bussiness-advertising/business-advertizing-04-min.webp",
    title: "Bussiness Advertising",
    desc: "Driving Growth, Amplifying Succes",
  },
  {
    url: "#",
    src1: "/img/project-custom/bussiness-advertising/business-advertizing-05-min.webp",
    src2: "/img/project-custom/bussiness-advertising/business-advertizing-06-min.webp",
    title: "Bussiness Advertising",
    desc: "Driving Growth, Amplifying Succes",
  },
  {
    url: "#",
    src1: "/img/project-custom/bussiness-advertising/business-advertizing-07-min.webp",
    src2: "/img/project-custom/bussiness-advertising/business-advertizing-08-min.webp",
    title: "Bussiness Advertising",
    desc: "Driving Growth, Amplifying Succes",
  },
  {
    url: "#",
    src1: "/img/project-custom/bussiness-advertising/business-advertizing-09-min.webp",
    src2: "/img/project-custom/bussiness-advertising/business-advertizing-10-min.webp",
    title: "Bussiness Advertising",
    desc: "Driving Growth, Amplifying Succes",
  },
  {
    url: "#",
    src1: "/img/project-custom/bussiness-advertising/business-advertizing-11-min.webp",
    src2: "/img/project-custom/bussiness-advertising/business-advertizing-12-min.webp",
    title: "Bussiness Advertising",
    desc: "Driving Growth, Amplifying Succes",
  },
  {
    url: "#",
    src1: "/img/project-custom/bussiness-advertising/business-advertizing-13-min.webp",
    src2: "/img/project-custom/bussiness-advertising/business-advertizing-14-min.webp",
    title: "Bussiness Advertising",
    desc: "Driving Growth, Amplifying Succes",
  },
  {
    url: "#",
    src1: "/img/project-custom/bussiness-advertising/business-advertizing-15-min.webp",
    src2: "/img/project-custom/bussiness-advertising/business-advertizing-16-min.webp",
    title: "Bussiness Advertising",
    desc: "Driving Growth, Amplifying Succes",
  },
];
const businessCard = [
  {
    url: "#",
    src1: "/img/project-custom/business-card/1-01.webp",
    src2: "/img/project-custom/business-card/2-01.webp",
    title: "Business Card",
    desc: "First Impressions, Lasting Impact",
  },
  {
    url: "#",
    src1: "/img/project-custom/business-card/5-01.webp",
    src2: "/img/project-custom/business-card/4-01.webp",
    title: "Business Card",
    desc: "First Impressions, Lasting Impact",
  },
  {
    url: "#",
    src1: "/img/project-custom/business-card/6-01.webp",
    src2: "/img/project-custom/business-card/7-01.webp",
    title: "Business Card",
    desc: "First Impressions, Lasting Impact",
  },
  {
    url: "#",
    src1: "/img/project-custom/business-card/8-01.webp",
    src2: "/img/project-custom/business-card/13-01.webp",
    title: "Business Card",
    desc: "First Impressions, Lasting Impact",
  },
  {
    url: "#",
    src1: "/img/project-custom/business-card/9-01.webp",
    src2: "/img/project-custom/business-card/12-01.webp",
    title: "Business Card",
    desc: "First Impressions, Lasting Impact",
  },
  {
    url: "#",
    src1: "/img/project-custom/business-card/3-01.webp",
    src2: "/img/project-custom/business-card/13-01.webp",
    title: "Business Card",
    desc: "First Impressions, Lasting Impact",
  },
];

function Portfolio() {
  const [attrib, setAttrib] = useState("#all");
  const getBtn = (e) => {
    e.preventDefault();
    const getAttribe = e.target.getAttribute("href");
    setAttrib(getAttribe);
    console.log(getAttribe);
  };

  return (
    <>
      <Helmet>
        <title>Portfolio – Innovatix Hub Australia</title>
        <meta
          name="description"
          content="Explore Innovatix Hub’s portfolio showcasing creative design projects. See how we bring unique visions to life with exceptional design work."
        />
        <meta name="robots" content="index,follow" />
        <meta name="author" content="Innovatix Hub" />
        <meta
          property="og:title"
          content="Portfolio – Innovatix Hub Australia"
        />
        <meta
          property="og:description"
          content="Explore Innovatix Hub’s portfolio showcasing creative design projects. See how we bring unique visions to life with exceptional design work."
        />
        <meta property="og:type" content="website" />
        <meta property="og:locale" content="en_AU" />
        <meta property="og:site_name" content="Innovatix Hub AU" />
        <meta
          property="og:url"
          content="https://innovatixhub.com.au/portfolio"
        />
        <meta
          property="og:image"
          content="https://innovatixhub.com.au/img/logo1.webp"
        />
        <link rel="canonical" href="https://innovatixhub.com.au/portfolio" />
      </Helmet>
      <Layout header={1} footer={1} className="" mainClassName="">
        <BreadcrumbArea
          title="Portfolio"
          subtitle={"Portfolio"}
          className={"pt-120 pb-50"}
        />
        <BtnTabs getId={getBtn} active={attrib} />
        <InnerProjectArea
          dark={true}
          items={logo_design}
          title="Logo Design"
          id={"logo-design"}
          active={attrib === "#logo-design" || attrib === "#all" ? true : false}
        />
        <InnerProjectArea
          dark={false}
          items={web_design}
          title="Web Design"
          id={"web-design"}
          active={attrib === "#web-design" || attrib === "#all" ? true : false}
        />
        <InnerProjectArea
          dark={true}
          items={brand_design}
          title="Brand Design"
          id={"brand-design"}
          active={
            attrib === "#brand-design" || attrib === "#all" ? true : false
          }
        />
        <InnerProjectArea
          dark={false}
          items={book_design}
          title="Book Design"
          id={"book-design"}
          active={attrib === "#book-design" || attrib === "#all" ? true : false}
        />
        <InnerProjectArea
          dark={true}
          items={stationary}
          title="Stationary"
          id={"stationary-design"}
          active={
            attrib === "#stationary-design" || attrib === "#all" ? true : false
          }
        />
        <InnerProjectArea
          dark={false}
          items={appDesign}
          title="Business Card"
          id={"app-design"}
          active={attrib === "#app-design" || attrib === "#all" ? true : false}
        />
        <InnerProjectArea
          dark={true}
          items={businessAdvertising}
          title="Business Advertising"
          id={"business-advertizing"}
          active={
            attrib === "#business-advertizing" || attrib === "#all"
              ? true
              : false
          }
        />
        <InnerProjectArea
          dark={false}
          items={businessCard}
          title="Business Card"
          id={"business-card"}
          active={
            attrib === "#business-card" || attrib === "#all" ? true : false
          }
        />
      </Layout>
    </>
  );
}

export default Portfolio;
